import classNames from 'classnames'
import Tooltip from 'rc-tooltip'
import { MdInfoOutline } from 'react-icons/md'

import type { ReactElement, ReactNode } from 'react'

import './styles.scss'

interface Props {
  className?: string
  id?: string
  label: string
  labelPosition?: 'top' | 'left'
  required?: boolean
  size?: SIZES
  tooltip?: ReactNode
}

const Label = ({
  className,
  id,
  label,
  labelPosition = 'top',
  required,
  size = 'medium',
  tooltip,
}: Props): ReactElement => {
  return (
    <label className={classNames('label-component', className, size, labelPosition)} htmlFor={id}>
      {label}{' '}
      {tooltip ? (
        <Tooltip overlay={tooltip} placement="top" trigger="hover">
          <div className="tooltip-icon-container">
            <MdInfoOutline className="tooltip-icon" size={15} />
          </div>
        </Tooltip>
      ) : null}{' '}
      {required ? <span className="mandatory-star">*</span> : null}
    </label>
  )
}

export default Label
